import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { ClipboardCheck, Maximize2, Loader2, Clock } from 'lucide-react';
import { apiRequest } from '../../lib/utils';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Button } from '../ui/button';
import { Badge } from '../ui/badge';

export default function PendingApprovalsWidget({ expandable, expandPath }) {
  const navigate = useNavigate();
  const [approvals, setApprovals] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    fetchApprovals();
  }, []);

  const fetchApprovals = async () => {
    try {
      const data = await apiRequest('/leave/pending-approvals');
      setApprovals(data.requests || data || []);
    } catch (error) {
      console.error('Failed to fetch approvals');
    } finally {
      setLoading(false);
    }
  };

  return (
    <Card data-testid="pending-approvals-widget">
      <CardHeader className="pb-2">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-2">
            <ClipboardCheck className="h-5 w-5 text-amber-500" />
            <CardTitle className="text-lg">Pending Approvals</CardTitle>
            {approvals.length > 0 && (
              <Badge variant="secondary">{approvals.length}</Badge>
            )}
          </div>
          {expandable && (
            <Button variant="ghost" size="icon" onClick={() => navigate(expandPath || '/admin/leave')} className="h-8 w-8">
              <Maximize2 className="h-4 w-4" />
            </Button>
          )}
        </div>
      </CardHeader>
      <CardContent>
        {loading ? (
          <div className="flex justify-center py-4">
            <Loader2 className="h-6 w-6 animate-spin text-slate-400" />
          </div>
        ) : approvals.length === 0 ? (
          <div className="text-center py-4 text-slate-400">
            <ClipboardCheck className="h-8 w-8 mx-auto mb-2 opacity-50" />
            <p className="text-sm">No pending approvals</p>
          </div>
        ) : (
          <div className="space-y-2">
            {approvals.slice(0, 3).map(request => (
              <div key={request.id} className="p-2 bg-amber-50 rounded border border-amber-200">
                <p className="font-medium text-sm text-slate-900">{request.employee_name || request.user_name}</p>
                <p className="text-xs text-slate-600">{request.type} - {request.days || 1} day(s)</p>
              </div>
            ))}
            {approvals.length > 3 && (
              <Button variant="ghost" size="sm" className="w-full" onClick={() => navigate(expandPath || '/admin/leave')}>
                View all {approvals.length} requests
              </Button>
            )}
          </div>
        )}
      </CardContent>
    </Card>
  );
}
